var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee-container",style:(("background-color: " + _vm.backgroundColor + ";color: " + _vm.color + ";border-bottom: 1px solid #FFE69C;"))},[_c('p',{staticClass:"marquee-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }